/**
* Created by lobin on 2020/6/17.
*/
<template>
  <div class="qrcode">
    <a-modal
        v-model="visible"
        title="站点二维码"
        width="600px"
        height="600px"
        :bodyStyle="{padding:0,height: '600px'}"
        @ok="() => visible = false"
    >
      <Poster :title="qrcodeConfig.title" :qrText="qrcodeConfig.qrcodeText" />
    </a-modal>
  </div>
</template>

<script type="text/babel">
import { stationQrcodeConfig } from '@/api/station';
import Poster from './poster.vue';

export default {
  components: {
    Poster,
  },
  data() {
    return {
      visible: false,
      qrcodeConfig: {

      },
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    async show(stationId) {
      const { data } = await stationQrcodeConfig(stationId);
      this.qrcodeConfig = data;
      this.visible = true;
    },
    handleUserInput() {

    },
    handlePickedLocation(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">

</style>
